import "./Newlaunch.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleCheck } from "@fortawesome/free-solid-svg-icons";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import flyer from "../../Assets/bintaro.webp";
const Newlaunch = () => {
  const waOpen = () => {
    window.open(
      `https://api.whatsapp.com/send/?phone=6285716429078&text=Halo+Wely,%20Saya%C2%A0bisa%20minta%20detail%20Katalog,%20Simulasi%20dan%20Promo%20terbaru%20(Newlaunch%20Calamus)%20Citra%20Garden%20Bintaro?%20https://www.marketingciputrabintaro.com/&type=phone_number&app_absent=0`,
      "_blank"
    );
  };
  const pointData = {
    poin1: ["Free DP", "Free Biaya KPR 1%", "Free Biaya BPHTB 5%"],
    poin2: ["Free Biaya Ajb", "Free PPN DTP 100%"],
  };
  return (
    <section id="newlaunch" className="section-newlaunch">
      <div className="container">
        <div className="flyer">
          <img src={flyer} alt="promo flyer" />
        </div>
        <div className="highlights">
          <h4>
            NEW LAUNCH <br /> <b>CALAMUS</b> <br />
            CITRA GARDEN BINTARO
          </h4>
          <div className="highlights-bottom">
            <div className="msg-hook">
              <div className="container-point">
                {pointData.poin1.map((item, index) => (
                  <div className="point-item" key={index}>
                    <FontAwesomeIcon icon={faCircleCheck} className="icon" />
                    <span>{item}</span>
                  </div>
                ))}
              </div>
              <div className="container-point">
                {pointData.poin2.map((item, index) => (
                  <div className="point-item" key={index}>
                    <FontAwesomeIcon icon={faCircleCheck} className="icon" />
                    <span>{item}</span>
                  </div>
                ))}
              </div>
              <div className="container-btn">
                <div className="term">*T&C apply</div>
                <button onClick={waOpen} className="btn">
                  <FontAwesomeIcon icon={faWhatsapp} className="icon" />
                  Hubungi Kami
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Newlaunch;
